/**
 * AuthPageSkeleton — Esqueleto para login / registro mientras carga el chunk.
 */
import { Skeleton, SkeletonForm } from "@/components/ui";

export function AuthPageSkeleton() {
  return (
    <div
      className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl p-6 sm:p-8 space-y-5 animate-fadeIn"
      role="status"
      aria-busy="true"
      aria-label="Cargando formulario"
    >
      <div className="text-center space-y-2">
        <Skeleton width="w-32" height="h-8" rounded="md" className="mx-auto" />
        <Skeleton width="w-48" height="h-4" rounded="md" className="mx-auto" />
      </div>
      <SkeletonForm fields={3} withHeader={false} />
      <Skeleton width="w-full" height="h-11" rounded="lg" />
    </div>
  );
}
